import { SvgIcon } from './SvgIcon'
import { Icon } from './Icon'
import { EmptyIcon } from './EmptyIcon'

export default {
  Icon,
  SvgIcon,
  EmptyIcon
}